import React from "react";

import { Models } from "api/types";
import { AccordionList } from "molecules/accordion-list/AccordionList";
import { ListModal } from "molecules/modal-window/list-modal/ListModal";

import { createFilterSections, FilterContent } from "./filterUtils";

interface ModalFilterInterfaceProps {
  open: boolean;
  onClose: () => void;
  concerns: Models<"ConcernModel">[];
  areas: Models<"AreaResult">[];
  brands?: Array<{ id: string; name: Models<"Translation"> }>;
  productTypes?: Array<{ id: string; name: Models<"Translation"> }>;
  fulfillmentOptions?: string[];
  hasSingleFulfillmentOption?: boolean;
  sortOptions?: { id: string; title: string }[];
  selectedConcerns: string[];
  selectedAreas: string[];
  selectedBrands?: string[];
  selectedInStoreAndDelivery?: string[];
  selectedProductTypes?: string[];
  selectedSort?: string;
  onConcernsChange: (concerns: string[]) => void;
  onAreasChange: (areas: string[]) => void;
  onBrandsChange?: (brands: string[]) => void;
  onProductTypesChange?: (productTypes: string[]) => void;
  onDeliveryChange?: (delivery: string[]) => void;
  onSortChange?: (sort: string) => void;
  onApply: () => void;
  onClearAll: () => void;
}

export const ModalFilterInterface: React.FC<ModalFilterInterfaceProps> = ({
  open,
  onClose,
  concerns,
  areas,
  brands = [],
  productTypes = [],
  fulfillmentOptions = [],
  hasSingleFulfillmentOption = false,
  sortOptions = [],
  selectedConcerns,
  selectedAreas,
  selectedBrands = [],
  selectedInStoreAndDelivery = [],
  selectedProductTypes = [],
  selectedSort = "featured",
  onConcernsChange,
  onAreasChange,
  onBrandsChange,
  onProductTypesChange,
  onDeliveryChange,
  onSortChange,
  onApply,
  onClearAll,
}) => {
  const filterSections = createFilterSections({
    data: {
      concerns,
      areas,
      brands,
      productTypes,
      fulfillmentOptions,
      hasSingleFulfillmentOption,
      sortOptions,
    },
    selections: {
      selectedConcerns,
      selectedAreas,
      selectedBrands,
      selectedInStoreAndDelivery,
      selectedProductTypes,
      selectedSort,
    },
    handlers: {
      onConcernsChange,
      onAreasChange,
      onBrandsChange: onBrandsChange!,
      onProductTypesChange: onProductTypesChange!,
      onDeliveryChange: onDeliveryChange!,
      onSortChange: onSortChange!,
    },
  });

  const accordionItems = filterSections.map((section) => ({
    title: section.title,
    children: <FilterContent section={section} />,
  }));

  return (
    <ListModal
      isRetailProducts
      open={open}
      onClose={onClose}
      title="FILTERS"
      size="fullscreen"
      firstButtonLabel="Apply"
      onFirstButtonClick={onApply}
      secondButtonLabel="Clear all"
      onSecondButtonClick={onClearAll}
    >
      <AccordionList items={accordionItems} />
    </ListModal>
  );
};
